module.exports = __webpack_public_path__ + "img/ic_flat_lower.a62376b2.svg";